import React, { useContext, useEffect, useState } from 'react'
import StepWizard, { StepWizardChildProps } from 'react-step-wizard'
import { useSTheme } from 'styles/theme'
import { useRouter } from 'next/router'

import { Box } from 'rebass'
import ReviewSummary from './ReviewSummary'
import ReviewElectronicSignature from './ReviewElectronicSignature'
import ReviewApplicationComplete from './ReviewApplicationComplete'

import { ApplicationContext } from 'v2/context/application'
import { OrganizationContext } from 'v2/context/organization'

interface Props {
    setCurrentStep?: (number) => void
    previousStepForWizard: (number) => void
    fontFamily: any
    updatePercentage: any
    requestNewDocumentFlow: boolean
}

const ReviewWizardContainer: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const applicationContext = useContext(ApplicationContext)
    const organizationContext = useContext(OrganizationContext)
    const router = useRouter()
    const [currentStep, setCurrentStep] = useState<number>(1)
    const [wizardKey, setWizardKey] = useState<number>(0)

    const theme = useSTheme()

    const longBeachFontFamily = theme.fonts.longBeach

    useEffect(() => {
        if (props.requestNewDocumentFlow) {
            setCurrentStep(3)
        }
    }, [props.requestNewDocumentFlow])

    useEffect(() => {
        if (applicationContext.application.id) {
            router.replace(
                `${organizationContext.program.urlFragment}/apply/${applicationContext.application.id}/review`
            )
        }
    }, [])

    useEffect(() => {
        if (applicationContext.application.completed) {
            setWizardKey((prevKey) => prevKey + 1)
        }
    }, [applicationContext.application.completed])

    return (
        <Box>
            <StepWizard
                key={wizardKey}
                initialStep={currentStep}
                transitions={{
                    enterRight: '',
                    enterLeft: '',
                    exitRight: '',
                    exitLeft: '',
                }}
                isLazyMount={true}
                onStepChange={(stepInfo: { previousStep: number; activeStep: number }) => {
                    setCurrentStep(stepInfo.activeStep)
                }}
            >
                {!applicationContext.application.completed && (
                    <ReviewSummary
                        applicationId={applicationContext.application.id}
                        personId={applicationContext.profile.personId}
                        fontFamily={longBeachFontFamily}
                        onNextStep={props.nextStep}
                        onPrevious={props.previousStepForWizard}
                        updatePercentage={props.updatePercentage}
                    />
                )}
                {!applicationContext.application.completed && (
                    <ReviewElectronicSignature
                        personId={applicationContext.profile.personId}
                        fontFamily={longBeachFontFamily}
                        onNextStep={props.nextStep}
                        onPrevious={props.previousStep}
                        updatePercentage={props.updatePercentage}
                    />
                )}
                <ReviewApplicationComplete fontFamily={longBeachFontFamily} updatePercentage={props.updatePercentage} />
            </StepWizard>
        </Box>
    )
}

export default ReviewWizardContainer
